import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CrowdFlowSensorSite } from '../../model/crowd-flow-sensor-site';
import { WebsocketService } from '../../service/websocket.service';
import { CrowdFlowSensorSiteState, CrowdFlowSensorSiteStore } from '../state/crowd-flow-sensor-site.store';
import { AkitaHTTPCrowdFlowSensorSiteService } from './akita-http-crowdflow-sensor-site.service';
import { UrlConfig } from '../../model/urlconfig';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CrowdFlowSensorSiteService extends NgEntityService<CrowdFlowSensorSiteState> implements UrlConfig{

  constructor(
    protected store: CrowdFlowSensorSiteStore,
    private httpCrowdFlowSensorSiteService: AkitaHTTPCrowdFlowSensorSiteService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('CrowdFlowSensorSite')
      .pipe(untilDestroyed(this))
      .subscribe((data: CrowdFlowSensorSite[]) => this.store.upsertMany(data));
  }

  getAll() {
    this.httpCrowdFlowSensorSiteService.getAll().subscribe(crowdFlows => this.store.add(crowdFlows));
  }

  getById(id: ID) {
    this.httpCrowdFlowSensorSiteService.loadById(id).subscribe(crowdFlows => this.store.add(crowdFlows));
  }

  updateEntitiesUrl(newUrl: string) {
    this.httpCrowdFlowSensorSiteService.setEntitiesUrl(newUrl);
  }
}
